
import { Component, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { CustomizerComponentHeaderComponent } from '@app/customizer/components';
import { SelectBoxComponent } from '@app/customizer/components/select-box/select-box';
import { ConfigurationService } from '@services/configuration.service';
import { ComponentVariantChangeModel } from '@models/component-variant-change';
import { DataApiService } from '@services/data-api.service';
import { EventsService } from '@services/events.service';
import { ImageService } from '@services/image.service';
import { SorterService } from '@services/sorter.service';
import { AngleConstants } from '@shared/angle-constants';
import { BaseCustomizerComponent } from '@shared/base-customizer-component';
import { ComponentVariantFromApiModel } from '@models/api-models/component-variant-fromapi';

@Component({
    selector: 'temple-design-by-finish-menu',
    template: `
        <customizer-component-header [menu]="menu" (updateCollapsedOnComponent)="updateCollapsed($event)">
          @if (designs.length) {
            <select-box
              [editMode]="state === customizerStateEnum.EDITORDER"
              [imageClass]="'temple-design'"
              [optionsImage]="getImage"
              [options]="designs"
              optionsText="Description"
              optionsId="Id"
              [selected]="getSelectedVariant"
              (selectedChange)="onSelected($event)"
              [optionsDiscontinued]="'Discontinued'"
              (matchColors)="matchColors(null)"
              [colorMatchMode]="true"
              [colorsAvailableForMatching]="allPossibleColorsOnOtherSelectedVariants"
              [currentColor]="getSelectedVariant.VariantColor"
              [variantOrModelIsNew]="modelIsNew"
              [matchColor]="menu.matchColor"
              >
            </select-box>
          }
        </customizer-component-header>
        `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CustomizerComponentHeaderComponent, SelectBoxComponent]
})
export class TempleDesignByFinishComponent extends BaseCustomizerComponent implements OnInit {

	public designs: Array<ComponentVariantFromApiModel> = [];

	constructor(
		public override events: EventsService,
		private imageService: ImageService,
		public apiService: DataApiService,
		public sorter: SorterService,
		public override configurationService: ConfigurationService
	) {
		super(events, apiService, configurationService);
	}

	async initData() {
		this.events.showLoader(true);

		await this.fetchData();
		this.setImageSliderByName(AngleConstants.Perspective);

		this.events.showLoader(false);
	}

	onChanges(changes: SimpleChanges): void {
	}

	getImage = (variant: ComponentVariantFromApiModel) => {
		return this.imageService.GetVariantPreciousImage(variant.ToComponentVariantModel(""), this.modelGroup.ProductLineCode);
	};

	onSelected(selected: ComponentVariantFromApiModel) {
		this.events.showLoader(true);
		const newVariant = selected.ToComponentVariantModel(this.getSelectedVariant.Engraving, this.getSelectedVariant.OrderLineUuid, true);
		this.updateVariantDesign(new ComponentVariantChangeModel(this.getSelectedVariant, newVariant, selected.VariantSizes));
	}

	async fetchData() {
		this.getSelectedVariant.VariantViewed = true;

		const finishIndicator = this.getSelectedVariant.Code.substring(this.getSelectedVariant.Code.indexOf(';'), this.getSelectedVariant.Code.length);

		let apidata = await this.configurationService.getVariants(this.configuration?.ModelConfigurationUuid, this.modelGroup, this.getSelectedVariant.Component.Uuid);
		apidata = apidata?.filter(a => a.Code.indexOf(finishIndicator) > -1);

		await this.RunDisablingSystem(apidata);
		this.designs = apidata?.sort(this.sorter.sortBy(ComponentVariantFromApiModel)) ?? [];

	}

}
